import { EgretLoadable } from 'egret';
import { authRoles } from '../../../auth/authRoles';

const TotalsPerUnit = EgretLoadable({
  loader: () => import('./index')
});

const Route = [
  {
    path: '/totalsperunit',
    exact: true,
    component: TotalsPerUnit,
    auth: authRoles.all,
  }
];

export default Route;
